  import { gql } from "@apollo/client";

  

  // Section for Update Claim

  export const UPDATE_CLAIM = gql`
    mutation updateClaim($input: updateClaimInput) {
      updateClaim(input: $input)
    }
  `;

  //  Section for Get Claim By Status //

  

  // Get Claim By Org

  

  //  Section for Create Medical Claim
  

  //  Section for Update Medical Error
  export const UPDATE_MEDICALCLAIM = gql`
    mutation updateMedicalClaim($input: updateMedicalClaimInput) {
      updateMedicalClaim(input: $input)
    }
  `;

  // Delete Claim
  

  // Delete Medical Claim
  

  // Section for Get Medical Claim by ORG
  

  // Section for Claim by Status

  

  

  

  // Get Claim By Id
  

  // Get Medical Claim By Id
  
